import { GLOBAL_SECTION } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/SectionHeading";
import { GlobalMap } from "@/components/world/GlobalMap";

export const GlobalPerspective = () => (
  <section
    id="global"
    data-testid="global-section"
    className="relative border-b border-border/70 py-24 lg:py-36"
  >
    <div className="shell">
      <div className="grid gap-14 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <SectionHeading
            eyebrow={GLOBAL_SECTION.eyebrow}
            lines={GLOBAL_SECTION.headline}
            compact
          />
          <Reveal delay={0.12}>
            <p className="mt-8 max-w-md text-sm leading-relaxed text-mist sm:text-base">
              {GLOBAL_SECTION.paragraph}
            </p>
          </Reveal>

          <Reveal delay={0.2}>
            <dl className="mt-12 space-y-px bg-border/60">
              {GLOBAL_SECTION.markers.map((marker, i) => (
                <div
                  key={marker.title}
                  data-testid={`global-marker-${i + 1}`}
                  className="flex items-baseline gap-5 bg-navy-950 py-5"
                >
                  <span
                    className={`mt-1 h-1.5 w-1.5 shrink-0 ${
                      i === 0 ? "bg-aqua-bright" : "bg-mist/60"
                    }`}
                  />
                  <dt className="w-28 shrink-0 text-sm font-medium uppercase tracking-[0.1em] text-offwhite sm:w-36">
                    {marker.title}
                  </dt>
                  <dd className="label-mono text-mist">{marker.detail}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pt-6">
          <Reveal delay={0.1}>
            <div className="relative overflow-hidden border border-border bg-[linear-gradient(160deg,hsl(var(--navy-900)),hsl(var(--navy-950)))] p-4 sm:p-8">
              <GlobalMap />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
